"use client";

import { buildListingFinancialHistory } from "@/components/listings/financial-history-model";
import { ListingFinancialHistoryChart } from "@/components/listings/listing-financial-history-chart";
import { ListingFinancialTimeline } from "@/components/listings/listing-financial-timeline";
import { api } from "@/lib/api-client";
import { useMemo } from "react";

export type ListingPriceHistoryProps = {
  listingId: number;
};

/**
 * Hidden until a tracked figure changes from one number to another.
 * First-time values already appear in the financials above.
 */
export function ListingPriceHistory({ listingId }: ListingPriceHistoryProps) {
  const { data, isLoading } = api.listings.getFinancialHistory.useQuery({
    listingId,
    limit: 50,
  });

  const history = useMemo(
    () => buildListingFinancialHistory(data?.snapshots ?? []),
    [data?.snapshots],
  );

  if (isLoading || !history) return null;

  return (
    <div className="mt-10 flex flex-col gap-4 border-t border-border pt-8">
      <p className="text-sm font-semibold text-foreground">Price history</p>
      {history.chart ? (
        <ListingFinancialHistoryChart chart={history.chart} />
      ) : null}
      <ListingFinancialTimeline events={history.events} />
    </div>
  );
}

ListingPriceHistory.displayName = "ListingPriceHistory";
